"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const ClockSendOutlineIcon = (_a) => {
    var { size, color } = _a, rest = __rest(_a, ["size", "color"]);
    return (react_1.default.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", version: "1.1", width: size || '1em', height: size || '1em', fill: color || 'currentColor', viewBox: "0 0 24 24" }, rest),
        react_1.default.createElement("path", { d: "m11 7h2v5.4l-4.5 4.5-1.4-1.4 3.9-3.9zm-7 5c0-4.4 3.6-8 8-8s8 3.6 8 8c0 1-.2 2-.6 3l1.8.9c.5-1.2.8-2.5.8-3.9 0-5.5-4.5-10-10-10s-10 4.5-10 10 4.5 10 10 10v-2c-4.4 0-8-3.6-8-8zm10 5.5 6 1-6 1v3l8.5-4-8.5-4z" })));
};
exports.default = ClockSendOutlineIcon;
